import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-analyticscallanalysis',
  templateUrl: './analyticscallanalysis.component.html',
  styleUrls: ['./analyticscallanalysis.component.css']
})
export class AnalyticscallanalysisComponent implements OnInit {
  @Input('details') details: any;
  @Input('average_calls_per_month') average_calls_per_month: number;
  @Input('average_monthly_cost') average_monthly_cost: number;
  constructor() {
  }

  ngOnInit() {
  }

  findAverage(prop) {
    let total = 0;
    for (let i = 0; i < this.details.data.calls.length; i++) {
      total = this.details.data.calls[1].call_count;
    }
  }
}
